import { useState } from 'react';

const initialState = {
  type: null,
  code: null,
  message: null,
  additional: null,
};

export const useNotices = () => {
  const storedNotice = typeof window !== 'undefined' && localStorage.getItem('currentNotice') || null;
  const defaultState = storedNotice && JSON.parse(storedNotice) || initialState;
  const [notices, setNotices] = useState(defaultState);

  const handleSetNotice = (newNotice) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('currentNotice', JSON.stringify(newNotice));
    }
    setNotices(newNotice);
  }

  const removeNotice = () => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('currentNotice');
    }

    setNotices(initialState);
  };

  return { notices, setNotices: handleSetNotice, removeNotice };
};
